import { globalObject } from './globalObject';
export function sendToExtension(type, payload) {
    const callback = globalObject.__ooBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type, payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map